import { getConfig } from '@local/app-config';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { ErrorResponse } from '../types';

const bentleyIdentityBaseQuery: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError | ErrorResponse
> = async (args, WebApi, extraOptions) => {
    const bentleyIdentityBaseUrl = getConfig().bentleyBaseUrl;
    const rawBaseQuery = fetchBaseQuery({
        baseUrl: bentleyIdentityBaseUrl,
    });
    return rawBaseQuery(args, WebApi, extraOptions);
};

export const BentleyIdentityApiClient = createApi({
    reducerPath: 'bentleyIdentityAPI',
    baseQuery: bentleyIdentityBaseQuery,
    endpoints: () => ({}),
});
